// Components
import Overlay from "@scripts/components/overlay";
import TogglePanel from "@scripts/components/toggle-panel";
import FundingDestinationsList from "@scripts/components/funding-destinations-list";

// Funding destinations page module
class FundingDestinationsPage {
    constructor(el) {
        this.el = el;
        this.init();
    }

    init() {
        this.initTogglePanels();
        this.initFundingOptionsList();
        this.initFundingOptionsForm();
    }

    initFundingOptionsList() {
        const fundingDestinationsListEl = document.querySelector(".js-funding-destinations-list");
        this.fundingDestinationsList = new FundingDestinationsList(fundingDestinationsListEl);
    }

    initFundingOptionsForm() {
        const formOverlay = new Overlay({ target: this.el });
        const fundingForm = document.querySelector(".js-funding-destinations-form");

        fundingForm.addEventListener("submit", (e) => {
            var isValid = this.fundingDestinationsList.validate();

            if (!isValid) {
                e.preventDefault();
                return false;
            }

            formOverlay.show();
        });
    }

    initTogglePanels() {
        const togglePanelElms = document.querySelectorAll(".js-toggle-panel");
        for (var i = 0; i < togglePanelElms.length; i++) {
            new TogglePanel(togglePanelElms[i]);
        }
    }
}

// Startup
document.addEventListener('DOMContentLoaded', () => {
    const el = document.getElementById("js-fd-page");
    if (el) new FundingDestinationsPage(el);
});